import React from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import PartnerSidebar from "./PartnerSidebar";

const PartnerLayout = () => (
  <div
    className="partner-landing min-h-screen bg-[#080A0F] text-partner flex"
    data-testid="partner-dashboard-shell"
  >
    <PartnerSidebar />
    <div className="flex-1 md:ml-64">
      <main className="px-4 sm:px-6 lg:px-8 py-8 md:py-10 max-w-6xl">
        <Outlet />
      </main>
    </div>
    <Toaster theme="dark" position="top-right" richColors />
  </div>
);

export default PartnerLayout;
